import { Input } from 'components/ui/input';
import { botFormInputs } from './BotInfoForm';
import { BadgeAlert } from 'lucide-react';
import BotInfo from '../modals/BotInfo';
// import { useState } from 'react';
import { Button } from 'components/ui/button';
import useIsMobile from 'hooks/useIsMobile';

interface formStepOne {
  botInputs: botFormInputs;
  setBotInputs: React.Dispatch<React.SetStateAction<botFormInputs>>;
  handleContinue?: () => void;
}

const FormInputs = ({
  label,
  onChange,
  // fieldMap,
  placeholder,
  value,
}: {
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fieldMap: { [key: string]: string };
  placeholder: string;
  value?: string;
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-1 items-center">
        <label className="text-[14px] font-medium ">{label}</label>
        <BotInfo>
          <div className="w-8 h-8 flex items-center">
            <BadgeAlert
              size={15}
              className={`cursor-pointer ${label === 'Telegram Bot Token' ? 'block' : 'hidden'}`}
            />
          </div>
        </BotInfo>
      </div>
      <Input
        className="h-10 focus:outline-none focus:ring-0 placeholder:text-[#B8BCBA] placeholder:font-normal placeholder:text-[16px] focus:border-[#846CEC] dark:bg-[#2B2B2B] dark:border-gray-700 dark:text-white"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

const FormStepOne = ({
  botInputs,
  setBotInputs,
  handleContinue,
}: formStepOne) => {
  const isMobile = useIsMobile();
  const fieldMap: { [key: string]: keyof botFormInputs } = {
    'Telegram Bot Token': 'token',
    'Bot Name': 'name',
    'Bot Description': 'description',
  };
  // const [showToolTip, setShowTooltip] = useState(false);

  const handleInputChange =
    (field: keyof botFormInputs) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setBotInputs((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    };

  return (
    <div className="p-10 pb-12 w-full md:w-[50%] rounded-l-md dark:text-white">
      <div className="flex flex-col gap-2">
        {/* heading */}
        <div className="text-left flex flex-col gap-1/2">
          <h3 className="text-[14px] uppercase font-semibold">STEP 1</h3>
          <h1 className="text-[28px] font-bold">Enter bot details</h1>
        </div>
        {/* inputs */}
        <div className="flex flex-col gap-4 mt-4">
          <FormInputs
            label="Telegram Bot Token"
            onChange={handleInputChange('token')}
            fieldMap={fieldMap}
            placeholder="Enter token"
            value={botInputs.token}
          />
          <FormInputs
            label="Bot Name"
            onChange={handleInputChange('name')}
            fieldMap={fieldMap}
            placeholder="Enter name"
            value={botInputs.name}
          />
          <FormInputs
            label="Bot Description"
            onChange={handleInputChange('description')}
            fieldMap={fieldMap}
            placeholder="Enter description"
            value={botInputs.description}
          />
          <div className="flex flex-col gap-3">
            <label className="text-[14px] font-medium ">Welcome Message</label>
            <textarea
              title="message"
              className="resize-none focus:outline-none focus:ring-0 placeholder:text-[#B8BCBA] placeholder:font-normal placeholder:text-[16px] border border-gray-200 dark:border-gray-700 rounded-md corder bg-background dark:bg-[#2B2B2B] h-[80px] focus:border-[#846CEC] p-2 dark:text-white"
              placeholder="Enter welcome message"
              value={botInputs.tele_welcome_msg}
              onChange={(e) =>
                setBotInputs((prev) => ({
                  ...prev,
                  tele_welcome_msg: e.target.value,
                }))
              }
            />
          </div>
        </div>
        {isMobile ? (
          <Button
            className="text-base w-full"
            onClick={(e) => {
              e.preventDefault();
              handleContinue?.();
            }}
          >
            Continue
          </Button>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default FormStepOne;
